// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"2e85bae9","43":"a2402db5","249":"38f2b289","543":"82926306"}[chunkId] + ".chunk.css";
};